import React, { useEffect } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

export const Alert = ({ isOpen, toggle, message }) => {
  return (
    <>
      {isOpen && (
        <SweetAlert
          title=''
          onConfirm={(e) => {}}
          customClass='my-alert'
          focusConfirmBtn={false}
          customButtons={
            <React.Fragment>
              <button
                className='btn btn-secondary w-25'
                onClick={toggle}
              >
                OK
              </button>
            </React.Fragment>
          }
        >
          {message}
        </SweetAlert>
      )}
    </>
  );
};
